/**
 * List · Split · Map.
 *
 * Three states rather than two because the useful one is the middle: the map answers "where",
 * the rows answer "which", and the question an analyst actually has needs both at once. List
 * and Map are the ends of that, for a small screen or a presentation.
 */
export const VIEWS = ["list", "split", "map"];
const LABEL = { list: "List", split: "Split", map: "Map" };

/**
 * `views` lets a page offer a subset. The pipeline board offers List and Map only: its
 * columns need the full width to be readable, and half a Kanban beside half a map is two
 * things done badly rather than one done well.
 */
export default function ViewToggle({ view, onChange, views = VIEWS }) {
  return (
    <div style={wrap} role="group" aria-label="View">
      {views.map((v) => (
        <button
          key={v}
          onClick={() => onChange(v)}
          aria-pressed={view === v}
          style={{ ...btn, ...(view === v ? active : null) }}
        >
          {LABEL[v]}
        </button>
      ))}
    </div>
  );
}

const wrap = { display: "inline-flex", border: "1px solid #cfd8dc", borderRadius: 6,
               overflow: "hidden", background: "#fff" };
const btn = { padding: "5px 14px", fontSize: 12, fontWeight: 600, border: "none",
              background: "transparent", color: "#546e7a", cursor: "pointer" };
const active = { background: "#1976d2", color: "#fff" };
